"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.search");
var _AddConfiguration = _interopRequireDefault(require("./AddConfiguration"));
var _allianceAuthorization = require("@/api/allianceAuthorization");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'TBAuthorization',
  components: {
    AddConfiguration: _AddConfiguration.default
  },
  props: {
    unionCode: {
      type: String,
      default: 'TB'
    }
  },
  data: function data() {
    return {
      tableData: [],
      total: 0,
      queryData: {
        unionCode: 'TB',
        userId: null,
        page: 1,
        size: 10
      },
      nameList: {
        TB: '淘宝联盟',
        JD: '京东联盟',
        WPH: '唯品会联盟',
        PDD: '多多进宝'
      },
      CaseConversion: {
        'jd': 'JD',
        'tb': 'TB',
        'pdd': 'PDD',
        'wph': 'WPH'
      }
    };
  },
  created: function created() {
    this.queryData.userId = this.$store.getters.userId;
    this.onListBasePaged();
    var urlParams = new URLSearchParams(window.location.search);
    var code = urlParams.get('code'); // 获取 code 的值
    var state = urlParams.get('state'); // 获取 code 的值
    var unionCode = urlParams.get('unionCode'); // 获取 code 的值
    console.log(code, state, unionCode);
    var authCode = localStorage.getItem('newAuthCode') ? JSON.parse(localStorage.getItem('newAuthCode')) : '';
    if (code && code !== authCode) {
      localStorage.setItem('newAuthCode', JSON.stringify(code));
      this.authCallback(this.CaseConversion[unionCode], code, state);
    }
  },
  methods: {
    onSaveSuccess: function onSaveSuccess() {
      this.queryData.page = 1;
      this.queryData.size = 10;
      this.onListBasePaged();
    },
    onAdd: function onAdd() {
      this.$refs.addConfiguration.openDialog({
        operationType: 'add',
        unionCode: this.unionCode
      });
    },
    onEdit: function onEdit(row) {
      this.$refs.addConfiguration.openDialog({
        operationType: 'edit',
        unionCode: this.unionCode,
        unionBaseId: row.unionBaseId
      });
    },
    onDelete: function onDelete(row) {
      var _this = this;
      if (row.active === 1) {
        this.$confirm('默认账号不能删除,需调整为非默认账号才可删除!', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {});
        return false;
      }
      this.$confirm('是否确认删除联盟账号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.onDeleteApi(row.unionBaseId);
      });
    },
    setDefault: function setDefault(row) {
      var _this2 = this;
      this.$confirm('确认设置为默认联盟账号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        message: "\n          <div style=\"margin: 0;\">\n            <div style=\"font-size: 18px; color: #333; font-weight: normal; margin-bottom: 8px;text-align: center;\">\n              \u786E\u8BA4\u8BBE\u7F6E\u4E3A\u9ED8\u8BA4\u8054\u76DF\u8D26\u53F7\uFF1F\n            </div>\n            <div style=\"font-size: 14px; color: #f56c6c; margin-top: 4px;text-align: center;\">\n              \u6CE8\uFF1A\u786E\u8BA4\u540E\uFF0C\u539F\u5148\u9ED8\u8BA4\u8D26\u53F7\u5C06\u88AB\u66FF\u6362\uFF0C\u8C28\u614E\u64CD\u4F5C\n            </div>\n          </div>\n        ",
        dangerouslyUseHTMLString: true
      }).then(function () {
        _this2.setDefaultApi(row.unionBaseId);
      });
    },
    onListBasePaged: function () {
      var _onListBasePaged = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              params = {
                unionCode: this.unionCode,
                userId: this.queryData.userId,
                page: this.queryData.page,
                size: this.queryData.size
              };
              _context.n = 1;
              return (0, _allianceAuthorization.listBasePaged)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.tableData = res.data.data || [];
                this.total = res.data.total || 0;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function onListBasePaged() {
        return _onListBasePaged.apply(this, arguments);
      }
      return onListBasePaged;
    }(),
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.onListBasePaged();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.onListBasePaged();
    },
    // 删除联盟账号
    onDeleteApi: function () {
      var _onDeleteApi = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(id) {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              params = {
                unionBaseId: id,
                unionCode: this.unionCode,
                userId: this.queryData.userId
              };
              _context2.n = 1;
              return (0, _allianceAuthorization.removeBase)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$message({
                  type: 'success',
                  message: '删除成功'
                });
                this.queryData.page = 1;
                this.queryData.size = 10;
                this.onListBasePaged();
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function onDeleteApi(_x) {
        return _onDeleteApi.apply(this, arguments);
      }
      return onDeleteApi;
    }(),
    // 设置默认联盟账号
    setDefaultApi: function () {
      var _setDefaultApi = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(id) {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              params = {
                unionBaseId: id,
                unionCode: this.unionCode,
                userId: this.queryData.userId
              };
              _context3.n = 1;
              return (0, _allianceAuthorization.setActive)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$message({
                  type: 'success',
                  message: '设置成功'
                });
                this.queryData.page = 1;
                this.queryData.size = 10;
                this.onListBasePaged();
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function setDefaultApi(_x2) {
        return _setDefaultApi.apply(this, arguments);
      }
      return setDefaultApi;
    }(),
    // 更新授权
    onUpdateAuth: function () {
      var _onUpdateAuth = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(row) {
        var _this3 = this;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.$confirm('是否确认更新授权?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(function () {
                _this3.onLoadOauthUrl(row);
              });
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function onUpdateAuth(_x3) {
        return _onUpdateAuth.apply(this, arguments);
      }
      return onUpdateAuth;
    }(),
    onLoadOauthUrl: function () {
      var _onLoadOauthUrl = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5(row) {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              params = {
                unionBaseId: row.unionBaseId,
                unionCode: this.unionCode
              };
              _context5.n = 1;
              return (0, _allianceAuthorization.loadOauthUrl)(params);
            case 1:
              res = _context5.v;
              if (res.code === 0) {
                window.open(res.data.authUrl);
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function onLoadOauthUrl(_x4) {
        return _onLoadOauthUrl.apply(this, arguments);
      }
      return onLoadOauthUrl;
    }(),
    authCallback: function () {
      var _authCallback = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6(unionCode, code, state) {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              params = {
                unionCode: unionCode,
                code: code,
                state: state
              };
              _context6.n = 1;
              return (0, _allianceAuthorization.saveOauth)(params);
            case 1:
              res = _context6.v;
              console.log('res', res);
              if (res.code === 0) {
                if (res.data) {
                  this.onListBasePaged();
                  this.$notify.success({
                    title: '温馨提示',
                    message: '操作成功'
                  });
                } else {
                  this.$notify.error({
                    title: '温馨提示',
                    message: '操作失败'
                  });
                }
              }
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t = _context6.v;
              console.log(_t);
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function authCallback(_x5, _x6, _x7) {
        return _authCallback.apply(this, arguments);
      }
      return authCallback;
    }()
  }
};